<template>
  <div v-if="isActive" :id="'tab-' + name" role="tabpanel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },

    active: {
      type: Boolean,
      required: false,
    },

    name: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    isActive() {
      return this.tabset?.selected === this;
    },
  },

  created() {
    if (this.tabset) this.tabset.register(this);
  },

  beforeDestroy() {
    if (this.tabset) this.tabset.unregister(this);
  },

  inject: {
    tabset: {
      from: 'tabset',
      default: null,
    },
  },
};
</script>
